export const hero = {
  en: {
    subtitle: 'AI Developer | GenAI | Machine Learning | LLMs | CNNs',
    cta: 'Explore My Work'
  },
  pt: {
    subtitle: 'Desenvolvedor em IA | IA Generativa | Aprendizagem de Máquina | LLMs | CNNs',
    cta: 'Explore Meu Trabalho'
  }
};